const { forwardRef, useImperativeHandle } = require('react')
const { useInbox } = require('store')

const InboxStateController = forwardRef((props, ref) => {
	const {
		reloadInbox,
		expandedInbox,
		setExpandedInbox,
		setForceInboxUpdate,
	} = useInbox()

	useImperativeHandle(
		ref,
		() => {
			return {
				reloadInbox,
				expandedInbox,
				setExpandedInbox,
				setForceInboxUpdate,
			}
		},
		[expandedInbox, reloadInbox, setExpandedInbox, setForceInboxUpdate]
	)

	return null
})

export default InboxStateController
